/**
 * One-time script to clear corrupted authentication data
 * This will run once and then remove itself
 */

import { safeLocalStorage } from './safe-storage';

export function clearCorruptedAuthData() {
  if (typeof window === 'undefined') return;

  try {
    // Check if we've already run this cleanup
    const cleanupRun = safeLocalStorage.getItem('auth-cleanup-v1');
    if (cleanupRun) return;



    // Get the stored data to check if it's corrupted
    const storedUser = safeLocalStorage.getItem('user');
    const storedAuth = safeLocalStorage.getItem('auth-storage');

    let needsCleanup = false;

    // Check if user data is corrupted
    if (storedUser) {
      try {
        JSON.parse(storedUser);
      } catch (error) {

        needsCleanup = true;
      }
    }

    // Check if auth storage is corrupted
    if (storedAuth) {
      try {
        JSON.parse(storedAuth);
      } catch (error) {

        needsCleanup = true;
      }
    }

    // Clear corrupted data
    if (needsCleanup) {

      safeLocalStorage.removeItem('user');
      safeLocalStorage.removeItem('token');
      safeLocalStorage.removeItem('auth-storage');

    }

    // Mark cleanup as completed
    safeLocalStorage.setItem('auth-cleanup-v1', 'completed');

  } catch (error) {
    console.error('Error during auth cleanup:', error);
  }
}
